import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const TitleSubscribeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const SubscribeIcon = styled.div<{ active: boolean }>`
  cursor: pointer;
  height: 20px;
  position: relative;
  svg {
    color: ${(props) => props.theme.color.purple.default};
    z-index: 1;
  }

  ${(props) =>
    props.active &&
    `
    &:after {
      content: '';
      position: absolute;
      border-radius: 4px;
      z-index: 0;
      background-color: ${props.theme.color.blue.default};
      top: -4px;
      left: -4px;
      width: 28px;
      height: 28px;
    }
    svg {
      color: ${props.theme.color.light.default};
    };
  `}
`;

export const FooterLink = styled(Link)`
  display: block;
  cursor: pointer;
  color: ${(props) => props.theme.color.blue.default};
  margin: 0;
  font-weight: 400;

  &:hover {
    text-decoration: underline;
  }

  &:not(:last-of-type) {
    margin-bottom: 5px;
  }
`;

export const Container = styled.div`
  margin-top: 5px;
`;

export const Wrapper = styled.div`
  display: flex;
`;

export const Label = styled.div`
  font-weight: 500;
  flex-shrink: 1;
  font-size: 14px;
`;

export const Value = styled.div`
  margin-left: auto;
`;

export const MatchText = styled.p`
  margin: 0;
  margin-top: 5px;
  font-weight: 600;
  color: ${(props) => props.theme.color.blue.default};
  font-size: 14px;
`;
